import React from "react";

const Lozenge = (props) => {
  // Keep consistent with Cushion/Hexagon
  const viewBoxWidth = 96;
  const viewBoxHeight = 86;

  // Overlay helpers (percent → absolute)
  const x = (percentX) => percentX * viewBoxWidth;
  const y = (percentY) => percentY * viewBoxHeight;

  // Measurement label positions (match your Cushion pattern)
  const lengthXPrcnt = 0.15;
  const lengthYPrcnt = 0.5;

  const widthXPrcnt = 0.65;
  const widthYPrcnt = 0.22;

  const lengthX = lengthXPrcnt * viewBoxWidth;
  const lengthY = lengthYPrcnt * viewBoxHeight;

  const widthX = widthXPrcnt * viewBoxWidth;
  const widthY = widthYPrcnt * viewBoxHeight;

  const lineColor = "#4a4a4a";
  const diagramStrokeWidth = "0.01";
  const diagramFontSize = 0.05;

  // --- Fit original lozenge geometry into this 96x86 box ---
  // Original SVG bounds (from your lozenge SVG)
  const origW = 63.06;
  const origH = 86.35;

  // Small padding to prevent stroke clipping
  const pad = props.pad ?? 1.0;

  const innerW = viewBoxWidth - 2 * pad;
  const innerH = viewBoxHeight - 2 * pad;

  const s = Math.min(innerW / origW, innerH / origH);
  const tx = pad + (innerW - origW * s) / 2;
  const ty = pad + (innerH - origH * s) / 2;

  const stroke = props.color || "#000";

  const cls = {
    fill: "none",
    stroke,
    strokeWidth: props.stroke_width ?? 2,
    strokeMiterlimit: 10,
    vectorEffect: "non-scaling-stroke",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={props.width}
      height={props.height}
      preserveAspectRatio={props.preserveAspectRatio}
      style={{ display: "block" }}
    >
      {/* Centered & scaled lozenge geometry */}
      <g transform={`translate(${tx}, ${ty}) scale(${s})`}>
        <polygon
          style={cls}
          points="31.7 11.35 54.76 42.88 31.7 74.76 8.42 42.77 31.7 11.35"
        />
        <polygon
          style={cls}
          points="31.59 .84 62.44 42.43 31.7 85.49 .62 42.66 31.59 .84"
        />
        <polygon
          style={cls}
          points="31.7 18.81 13.84 43.22 31.47 67.75 49.45 42.88 31.7 18.81"
        />
        <path style={cls} d="M31.7,18.81l-.11-17.97.11,17.97Z" />
        <path style={cls} d="M49.45,42.88h12.77-12.77Z" />
        <path style={cls} d="M31.7,85.49l-.23-17.74.23,17.74Z" />
        <path style={cls} d="M.62,42.66l13.11.11-13.11-.11Z" />
      </g>

      {/* Optional measurement overlay (same style/behavior as Cushion) */}
      {props.show_diagram && (
        <>
          {/* Vertical "Length" ruler */}
          <line
            x1={x(0.25)}
            y1={y(-0.01)}
            x2={x(0.25)}
            y2={y(0.98)}
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(0.23)}
            y1={y(-0.01)}
            x2={x(0.27)}
            y2={y(-0.01)}
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(0.23)}
            y1={y(0.98)}
            x2={x(0.27)}
            y2={y(0.98)}
            stroke={lineColor}
            strokeWidth=".6"
          />
          <rect
            x={lengthX}
            y={lengthY}
            width="20"
            height="11"
            rx="0.8"
            fill="white"
          />
          <text
            x={lengthX + 2}
            y={lengthY + 4}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            Length:
          </text>
          <text
            x={lengthX + 1}
            y={lengthY + 10}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            {props?.diamond?.Measurement1}
          </text>

          {/* Horizontal "Width" ruler */}
          <line
            x1={x(-0.008)}
            y1="25"
            x2={x(0.965)}
            y2="25"
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(-0.008)}
            y1="23"
            x2={x(-0.008)}
            y2="27"
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(0.965)}
            y1="23"
            x2={x(0.965)}
            y2="27"
            stroke={lineColor}
            strokeWidth=".6"
          />
          <rect
            x={widthX}
            y={widthY}
            width="19"
            height="11"
            rx="0.8"
            fill="white"
          />
          <text
            x={widthX + 2}
            y={widthY + 4}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            Width:
          </text>
          <text
            x={widthX + 1}
            y={widthY + 10}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            {props?.diamond?.Measurement2}
          </text>
        </>
      )}
    </svg>
  );
};

export default Lozenge;
